import React, { CSSProperties, FC } from "react";
import st from './styles.module.scss'
import StickerHeader from "../../../components/elements/sticker/StickerHeader";
import { TextType } from "@baseTypes/baseType";
import Tx from "../../../types/naming";
import cn from "classnames";

export const Empty = () => {
    return <div className={st.empty_block}>
        <StickerHeader
            textType={TextType.Header}
            title={Tx.Culture}
            rightPlacement={() => "0 Га"}
        />
        <div className={st['empty_block__chart']}>
            <svg xmlns="http://www.w3.org/2000/svg" width="352" height="298" viewBox="0 0 352 298" fill="none">
                <g clipPath="url(#clip0_11156_6384)">
                    <rect x="0.5" y="0.5" width="351" height="23" rx="4.5" fill="#E6E6E6" stroke="#E6E6E6"/>
                    <rect x="64.582" y="0.5" width="204.616" height="23" fill="#E6E6E6" stroke="#E6E6E6"/>
                    <rect x="64.582" y="0.5" width="204.616" height="23" fill="#E6E6E6" stroke="#E6E6E6"/>
                    <rect x="64.582" y="0.5" width="149.531" height="23" fill="#E6E6E6" stroke="#E6E6E6"/>
                    <rect x="64.582" y="0.5" width="81.5932" height="23" fill="#E6E6E6" stroke="#E6E6E6"/>
                    <rect x="29.6614" y="0.5" width="33.9208" height="23" fill="#E6E6E6" stroke="#E6E6E6"/>
                    <path d="M0.5 5C0.5 2.51472 2.51472 0.5 5 0.5H28.6613V23.5H5C2.51471 23.5 0.5 21.4853 0.5 19V5Z"
                          fill="#E6E6E6" stroke="#E6E6E6"/>
                    <g clipPath="url(#clip1_11156_6384)">
                        <rect y="40" width="174" height="14" rx="7" fill="#E6E6E6"/>
                        <rect x="300" y="40" width="52" height="14" rx="7" fill="#E6E6E6"/>
                        <circle cx="8" cy="88" r="4.5" fill="#E6E6E6" stroke="#E6E6E6"/>
                        <rect x="22" y="78" width="165" height="12.25" rx="6.125" fill="#E6E6E6"/>
                        <rect x="276" y="78" width="76" height="12.25" rx="6.125" fill="#E6E6E6"/>
                        <circle cx="8" cy="118" r="4.5" fill="#E6E6E6" stroke="#E6E6E6"/>
                        <rect x="22" y="108" width="179" height="12.25" rx="6.125" fill="#E6E6E6"/>
                        <rect x="301" y="108" width="51" height="12.25" rx="6.125" fill="#E6E6E6"/>
                        <circle cx="8" cy="148" r="4.5" fill="#E6E6E6" stroke="#E6E6E6"/>
                        <rect x="22" y="138" width="178" height="12.25" rx="6.125" fill="#E6E6E6"/>
                        <rect x="263" y="138" width="89" height="12.25" rx="6.125" fill="#E6E6E6"/>
                        <circle cx="8" cy="178" r="4.5" fill="#E6E6E6" stroke="#E6E6E6"/>
                        <rect x="20" y="168" width="191" height="12.25" rx="6.125" fill="#E6E6E6"/>
                        <rect x="273" y="168" width="79" height="12.25" rx="6.125" fill="#E6E6E6"/>
                        <circle cx="8" cy="208" r="4.5" fill="#E6E6E6" stroke="#E6E6E6"/>
                        <rect x="22" y="198" width="112" height="12.25" rx="6.125" fill="#E6E6E6"/>
                        <rect x="296" y="198" width="56" height="12.25" rx="6.125" fill="#E6E6E6"/>
                        <circle cx="8" cy="238" r="5.5" fill="#E6E6E6" stroke="#E6E6E6"/>
                        <rect x="22" y="228" width="210" height="12.25" rx="6.125" fill="#E6E6E6"/>
                        <rect x="285" y="228" width="67" height="12.25" rx="6.125" fill="#E6E6E6"/>
                    </g>
                </g>
                <defs>
                    <clipPath id="clip0_11156_6384">
                        <rect width="352" height="298" fill="white"/>
                    </clipPath>
                    <clipPath id="clip1_11156_6384">
                        <rect width="352" height="258" fill="white" transform="translate(0 40)"/>
                    </clipPath>
                </defs>
            </svg>

            <div className={st['empty_block__shadow']}>
                <svg xmlns="http://www.w3.org/2000/svg" width="400" height="400" viewBox="0 0 400 400" fill="none">
                    <g filter="url(#filter0_d_11156_6436)">
                        <rect width="400" height="400" fill="url(#paint0_linear_11156_6436)"/>
                    </g>
                    <defs>
                        <filter id="filter0_d_11156_6436" x="-4" y="0" width="408" height="408"
                                filterUnits="userSpaceOnUse"
                                color-interpolation-filters="sRGB">
                            <feFlood floodOpacity="0" result="BackgroundImageFix"/>
                            <feColorMatrix in="SourceAlpha" type="matrix"
                                           values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                                           result="hardAlpha"/>
                            <feOffset dy="4"/>
                            <feGaussianBlur stdDeviation="2"/>
                            <feComposite in2="hardAlpha" operator="out"/>
                            <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
                            <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_11156_6436"/>
                            <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_11156_6436"
                                     result="shape"/>
                        </filter>
                        <linearGradient id="paint0_linear_11156_6436" x1="200" y1="42.6063" x2="200" y2="311.874"
                                        gradientUnits="userSpaceOnUse">
                            <stop offset="0.460045" stopColor="white" stopOpacity="0"/>
                            <stop offset="0.831741" stopColor="white" stopOpacity="0.958507"/>
                            <stop offset="1" stopColor="white"/>
                        </linearGradient>
                    </defs>
                </svg>
            </div>
        </div>
        <EmptyTextBlock subtitle={"Для просмотра выберите другие департамент или организацию"} />
    </div>
}


type EmptyTextBlockProps = {
    title?: string
    subtitle?: string
    className?: string
    style?: CSSProperties
}

export const EmptyTextBlock: FC<EmptyTextBlockProps> = (props) => {
    const {
        title = 'Данные по графику отсутствуют',
        subtitle = 'Для просмотра выберите другие департамент или организацию',
        className,
        style
    } = props;

    return <div className={cn(st.empty_block__text, className)} style={style}>
        <h3 className={st.empty_block__text_title}>{title}</h3>
        <div className={st.empty_block__text_description}>{subtitle}</div>
    </div>
}